import { createSlice } from '@reduxjs/toolkit';
import { buildQueryKey, EMPTY_SUMMARY } from './panel_transactions.constants';
import { initialPanelTransactions } from './panel_transactions.initial';
import { getPanelTransactions } from './thunks';

export const panelTransactionsSlice = createSlice({
    name: 'panel_transactions',
    initialState: initialPanelTransactions,
    reducers: {
        /** Descarta lo cargado (por ejemplo al cambiar de cliente buscado). */
        resetPanelTransactions: () => ({ ...initialPanelTransactions }),
    },
    extraReducers: (builder) => {
        builder.addCase(getPanelTransactions.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getPanelTransactions.fulfilled, (state, action) => {
            const result = action.payload;
            state.loading = false;
            state.items = result.items;
            state.total = result.total;
            state.summary = result.summary;
            state.historyAvailableFrom = result.historyAvailableFrom;
            state.page = result.page;
            state.pageSize = result.pageSize;
            state.scope = result.scope;
            state.customerEmail = result.query.customerEmail;
            state.transactionId = result.query.transactionId;
            state.paymentStatus = result.query.paymentStatus;
            state.paymentMethod = result.query.paymentMethod;
            state.yearMonth = result.query.yearMonth;
            state.loadedForKey = buildQueryKey(result.query);
        });
        builder.addCase(getPanelTransactions.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message ?? 'Error cargando las transacciones';
            // Sin datos válidos no se deja la tabla anterior en pantalla: el
            // comercial podría leerla como el resultado del filtro que pidió.
            state.items = [];
            state.total = 0;
            state.summary = EMPTY_SUMMARY;
            state.loadedForKey = null;
        });
    },
});

export const { resetPanelTransactions } = panelTransactionsSlice.actions;

export default panelTransactionsSlice.reducer;
